
import React from "react";
import { RegulationItem } from "../RegulationItem";
import { Bug } from "lucide-react";

export const WildlifePrecautions = () => {
  return (
    <RegulationItem 
      value="wildlife-precautions" 
      icon={Bug}
      iconColor="text-green-600"
      title="Wildlife Precautions"
    >
      <ul className="space-y-2 text-tribal-neutral list-disc pl-5">
        <li>Snakes are common (rattlesnakes, gopher snakes, racers, garter snakes). Stay alert.</li>
        <li>Give snakes plenty of room; back away slowly if encountered.</li>
        <li>Ticks: Regularly check yourself, children, and pets after being outdoors.</li>
        <li>Mosquitoes: Use insect repellent and wear long sleeves and pants, especially at dusk and dawn.</li>
      </ul>
    </RegulationItem>
  );
};
